import { ref} from "vue";

export function useInvoiceEnums() {




    const invoiceStatusEnums = ref({
        DRAFT: 'DRAFT',
        VALIDATED: 'VALIDATED',
        PAID: 'PAID',
        PARTIALLY_PAID: 'PARTIALLY_PAID',
        CANCELED: 'CANCELED',
        CREDIT_NOTE : 'CREDITNOTE',
        ARCHIVED : 'ARCHIVED'
    })


    return { invoiceStatusEnums }
}
